var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topImg"},[_c('div',{},[_c('img',{staticClass:"img-cover full-w",attrs:{"src":_vm.topProduct.ImagePath,"alt":""}})]),_c('div',{staticClass:"color-primary fwb mv2 fs15"},[_vm._v(_vm._s(_vm.topProduct.Introduction))])])}
var staticRenderFns = []

export { render, staticRenderFns }